import React, { Component } from 'react';

import Select from 'react-select';
import styled from 'styled-components';
import { Row, Button, Separator, Text } from '@cuemath/comps';
import {
  Input,
  Modal,
  Button as SemanticButton,
  Label as LinkLabel,
} from 'semantic-ui-react';
import { FileUpload } from 'styled-icons/fa-solid';
import Tooltip from 'comps/tooltip';
import { Info } from 'styled-icons/octicons/Info';
import COLOR from 'constants/colors';
import { epochToDate } from 'utils';

const FilterWrapper = styled(Row)`
  width: ${({ view }) => `${view ? '520px' : '800px'}`};
  padding-left: 15px;
  align-items: center;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 100px;
`;

const Field = styled.div`
  display: flex;
  gap: ${({ gap }) => `${gap ? '70px' : '0px'}`};
  justify-content: ${({ gap }) => `${gap ? 'none' : 'space-between'}`};
  width: ${({ view }) => `${view ? '540px' : '500px'}`};
`;

const Label = styled.label`
  padding-left: 4px;
  font-weight: 600;
`;

export const SelectInput = styled(Select)`
  width: 240px;
`;

const Upload = styled(FileUpload)`
  cursor: pointer;
`;

const FileName = styled(Text)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 140px;
  margin: auto;
`;

const Error = styled.div`
  height: 20px;
  margin-left: 210px;
  margin-top: 10px;
  width: max-content;
  font-family: monospace;
  font-size: 10px;
  color: ${({ view }) => `${view ? COLOR.NEGATIVE : COLOR.DARK_GREEN}`};
`;

const CursorDiv = styled.div`
  height: 0px;
  cursor: pointer;
`;

const ButtonDiv = styled.div`
  width: max-content;
  margin-left: 520px;
`;

const LabelDiv = styled.div`
  width: 90px;
`;

const SampleLink = styled.a`
  margin-left: 20px;
`;

const KEYS = {
  USER_TYPE: 'user_type',
  VIBE_NAME: 'vibe_name',
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  CODE: 'code',
  USERS_FILE_NAME: 'users_file_name',
};

const TYPE = ['student', 'teacher'];

const URL =
  'https://cuemath-intel.s3.ap-southeast-1.amazonaws.com/media/vibes/new_sample.csv';

class VibeComponent extends Component {
  render() {
    const {
      vibeObj,
      value,
      dateErrorMsg,
      dateSuccessMsg,
      showConfirmation,
      errorText,
      message,
      open,
      handleCancel,
      handleCreate,
      onConfirm,
      disableCreateVibe,
      setValue,
      handleEndDate,
      handleStartDate,
      createPostObj,
      isDisabled,
    } = this.props;
    const types = TYPE.map(type => ({ label: type, value: type }));
    const typeValue = setValue(value);
    const isButtonDisabled = disableCreateVibe();
    const {
      users_file_name: usersFileName,
      vibe_name: vibeName,
      code,
      start_date: startDate,
      end_date: endDate,
    } = vibeObj || {};
    const fileName = usersFileName && usersFileName[0] && usersFileName[0].name;
    const confirmationMessage = errorText || message;
    const today = new Date().toISOString().split('T')[0];
    const { VIBE_NAME, CODE, USER_TYPE, USERS_FILE_NAME } = KEYS || {};
    return (
      <>
        <FilterWrapper>
          <LabelDiv>
            <Label>{'Vibe Details'}</Label>
          </LabelDiv>
          <Field>
            <Input
              onChange={e => createPostObj(e.target.value, VIBE_NAME)}
              placeholder="Name"
              type="text"
              value={vibeName || ''}
            />
            <Row>
              <Input
                onChange={e => createPostObj(e.target.value, CODE)}
                placeholder="Paste Widget Code"
                type="text"
                value={code || ''}
              />
              <CursorDiv>
                <Tooltip
                  title={
                    <div>
                      data-tf-widget = "{' '}
                      <span
                        style={{ color: COLOR.DARK_GREEN, textDecoration: 'underline' }}
                      >
                        BcnohJ2L
                      </span>{' '}
                      "
                    </div>
                  }
                  position="top"
                  width="200px"
                  bgColor={COLOR.WHITE}
                  color={COLOR.BLACK}
                  height="max-content"
                >
                  <Info size={14} />
                </Tooltip>
              </CursorDiv>
            </Row>
          </Field>
        </FilterWrapper>
        <Separator height={80} transparent />
        <FilterWrapper>
          <LabelDiv>
            <Label>{'Duration'}</Label>
          </LabelDiv>
          <Field view>
            <Input
              onChange={handleStartDate}
              type="date"
              label="From"
              min={today}
              value={startDate ? epochToDate(startDate, 'YYYY-MM-DD') : ''}
            />
            <Input
              onChange={handleEndDate}
              type="date"
              label="To"
              min={today}
              value={endDate ? epochToDate(endDate, 'YYYY-MM-DD') : ''}
            />
          </Field>
        </FilterWrapper>
        <Error view={dateErrorMsg}>
          {dateErrorMsg && !dateSuccessMsg ? dateErrorMsg : dateSuccessMsg}
        </Error>
        <Separator height={50} transparent />
        <FilterWrapper>
          <LabelDiv>
            <Label>{'Users'}</Label>
          </LabelDiv>
          <Field gap={50}>
            <SelectInput
              onChange={selected => createPostObj(selected, USER_TYPE)}
              options={types}
              value={typeValue}
              placeholder="Type"
            />
            <Row>
              <div>
                <label htmlFor="file-upload">
                  <Upload size="40" />
                </label>
                <input
                  style={{ display: 'none' }}
                  type="file"
                  id="file-upload"
                  onChange={e => createPostObj(e.target.files, USERS_FILE_NAME)}
                  accept=".csv"
                  onClick={e => (e.target.value = null)}
                />
              </div>
              <FileName color={COLOR.PRIMARY}>
                {fileName || 'Upload csv file here.'}
              </FileName>
            </Row>
          </Field>
        </FilterWrapper>
        <Separator height={50} transparent />
        <SampleLink href={URL} download>
          <LinkLabel size="large" horizontal>
            Click here to download a sample CSV
          </LinkLabel>
        </SampleLink>
        <Separator height={40} transparent />
        <ButtonDiv>
          <Button
            disabled={isButtonDisabled}
            label="Create Vibe!"
            onClick={handleCreate}
          />
        </ButtonDiv>
        {showConfirmation && !errorText && !message && (
          <Modal open={open} size="tiny">
            <Modal.Header>Create a new vibe</Modal.Header>
            <Modal.Content>
              <p>Do you want to proceed?</p>
            </Modal.Content>
            <Modal.Actions>
              <SemanticButton
                disabled={isDisabled}
                loading={isDisabled}
                positive
                onClick={onConfirm}
              >
                Yes
              </SemanticButton>
              <SemanticButton negative disabled={isDisabled} onClick={handleCancel}>
                No
              </SemanticButton>
            </Modal.Actions>
          </Modal>
        )}
        {confirmationMessage && (
          <Modal onClose={handleCancel} open={open} size="tiny">
            <Modal.Header>{confirmationMessage}</Modal.Header>
          </Modal>
        )}
      </>
    );
  }
}

export default VibeComponent;
